// ===============================
// ReglesService.jsx
// ===============================
// Composant React qui lit regles_service.json et l'affiche joliment.
// ===============================

import React from "react";
import regles from "./regles_service.json";

const styles = {
  container: {
    maxWidth: "900px",
    margin: "30px auto",
    padding: "20px",
    fontFamily:
      "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    backgroundColor: "#f9fafb",
    borderRadius: "12px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
  },
  header: { textAlign: "center", marginBottom: "25px" },
  title: { fontSize: "34px", fontWeight: "bold", color: "#111827", marginBottom: "6px" },
  subtitle: { fontSize: "24px", color: "#6b7280" },
  card: {
    backgroundColor: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: "10px",
    padding: "16px",
    marginBottom: "15px",
  },
  cardTitle: { fontSize: "24px", fontWeight: 600, color: "#1f2937", marginBottom: "10px" },
  list: { paddingLeft: "20px", margin: 0 },
  listItem: { marginBottom: "6px", fontSize: "18px", color: "#374151" },
};

export default function ReglesService() {
  const t = regles?.temps_travail ?? {};
  const g = regles?.gardes ?? {};
  const c = regles?.conges ?? {};
  const notes = regles?.notes ?? [];

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>📋 Règles de Service</h1>
        <p style={styles.subtitle}>Paramètres communs appliqués à tous les secteurs</p>
      </div>

      {/* Temps de travail */}
      <div style={styles.card}>
        <h2 style={styles.cardTitle}>⏱️ Temps de travail</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}>Quota contractuel : {t.quota_contractuel} demi-journées / semaine</li>
          <li style={styles.listItem}>Activité non clinique : {t.non_clinique} demi-journées / semaine</li>
          <li style={styles.listItem}>Activité clinique minimale : {t.clinique_min} demi-journées / semaine</li>
        </ul>
      </div>

      {/* Gardes */}
      <div style={styles.card}>
        <h2 style={styles.cardTitle}>🌙 Gardes</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}>Garde en semaine : {g.semaine} demi-journées</li>
          <li style={styles.listItem}>Garde samedi : {g.samedi} demi-journées</li>
          <li style={styles.listItem}>Garde dimanche / férié : {g.dimanche_ferie} demi-journées</li>
        </ul>
      </div>

      {/* Congés */}
      <div style={styles.card}>
        <h2 style={styles.cardTitle}>🏖️ Congés</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}>Congés annuels (CA + RTT) : {c.annuels} jours / an</li>
          <li style={styles.listItem}>Congés formation (CF) : {c.formation} jours ouvrables / an</li>
        </ul>
      </div>

      {/* Notes */}
      {notes.length > 0 && (
        <div style={styles.card}>
          <h2 style={styles.cardTitle}>ℹ️ Notes</h2>
          <ul style={styles.list}>
            {notes.map((note, idx) => (
              <li key={idx} style={styles.listItem}>{note}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}